// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client/css/" + chunkId + "." + {"63":"6fcea0c6","475":"cd04560a","538":"bebcca09","558":"287af1b6","589":"ef573a0e","593":"510f5753","707":"d04bc675","721":"da8cfc49","825":"59660fca","955":"36e46d52"}[chunkId] + ".chunk.css";
};